import { render, staticRenderFns } from "./AddressCell.vue?vue&type=template&id=67af8f72&scoped=true"
import script from "./AddressCell.vue?vue&type=script&lang=js"
export * from "./AddressCell.vue?vue&type=script&lang=js"
import style0 from "./AddressCell.vue?vue&type=style&index=0&id=67af8f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af8f72",
  null
  
)

export default component.exports